import { CustomButton } from "../global/CustomButton"
import emailjs from "@emailjs/browser"
import { useState } from "react"
import "./contactForm.css"

export function ContactForm({ setMessageSuccess }) {
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [phone, setPhone] = useState("")
    const [message, setMessage] = useState("")

    const [inputErrors, setInputErrors] = useState({
        name: false,
        email: false,
        phone: false,
        message: false
    })

    async function sendEmail(e) {
        e.preventDefault()

        setInputErrors({
            name: !name ? true : false,
            email: !email ? true : false,
            phone: !phone ? true : false,
            message: !message ? true : false
        })
        
        try {
            if(!name || !email || !phone) {
                throw Error("Please enter all your details")
            }

            if(!message) {
                throw Error("Message cannot be empty")
            }

            const sendMessage = await emailjs.sendForm(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                e.target,
                process.env.REACT_APP_EMAILJS_API_PUBLIC_KEY
            )
    
            if(sendMessage) {
                setMessageSuccess(true)
            }
        } catch(error) {
            if(error.hasOwnProperty("status") && error.status === 412) {
                setMessageSuccess(false)
            }
        }
        
        e.target.reset()
    }

    function handleChange(newValue, updateFunction, fieldName) {
        updateFunction(newValue)
        setInputErrors({ ...inputErrors, [fieldName]: false })
    }

    return (
        <div className="contact-form p-4">

            <form onSubmit={sendEmail}>

                <div className="d-flex justify-content-between basic-info md-row">
                    <div
                        className={`input-field d-flex flex-column gap-1 ${inputErrors.name ? "red-field-error" : ""}`}>
                        <input
                            type="text"
                            className="custom-input"
                            name="sender-name"
                            placeholder="Your Name"
                            value={name}
                            onChange={(e) => handleChange(e.target.value, setName, "name")}   
                        />
                        <div className="align-items-center gap-2">
                            <div className="exclamation-mark"></div>
                            <div className="input-error">Please enter your name</div>
                        </div>
                    </div>
                    
                    <div
                        className={`input-field d-flex flex-column gap-1 ${inputErrors.email ? "red-field-error" : ""}`}>
                        <input
                            type="text"
                            className="custom-input"
                            name="sender-email"
                            placeholder="Your Email"
                            value={email}
                            onChange={(e) => handleChange(e.target.value, setEmail, "email")}     
                        />
                        <div className="align-items-center gap-2">
                            <div className="exclamation-mark"></div>
                            <div className="input-error">Please enter your email address</div>
                        </div>
                    </div>
                    
                    <div
                        className={`input-field d-flex flex-column gap-1 ${inputErrors.phone ? "red-field-error" : ""}`}>
                        <input
                            type="text"
                            className="custom-input"
                            name="sender-phone"
                            placeholder="Your Phone"
                            value={phone}
                            onChange={(e) => handleChange(e.target.value, setPhone, "phone")}  
                        />
                        <div className="align-items-center gap-2">
                            <div className="exclamation-mark"></div>
                            <div className="input-error">Please enter your phone number</div>
                        </div>
                    </div>
                    
                </div>

                <div
                    className={`message-field d-flex flex-column gap-1 ${inputErrors.message ? "red-field-error" : ""}`}>
                    <textarea
                        name="message"
                        className="custom-input"
                        rows="6"
                        placeholder="Your Message"
                        value={message}
                        onChange={(e) => handleChange(e.target.value, setMessage, "message")}  
                    >
                    </textarea>
                    <div className="align-items-center gap-2">
                        <div className="exclamation-mark"></div>
                        <div className="input-error">Message cannot be empty</div>
                    </div>
                </div>
                

                <div className="d-flex justify-content-end mt-3 ms-auto send-btn-div gap-3">
                    <CustomButton
                        color="primary"
                        text="Send Message"
                    />
                </div>

            </form>

        </div>
    )
}